import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ContactForm from './ContactForm';
import '../../styles/luxe-theme.css';
import './HowItWorksLuxe.css';

// Page « Questions fréquentes » (/faq, texte du fondateur, 2026-10-29). Chaque réponse a été vérifiée contre le fonctionnement réel
// (limites de photos, formats de fichiers, pays, quantité, retrait par les invités). Aucun prix écrit en dur : il se règle dans
// l'Admin, la réponse renvoie vers la page Tarifs. Mêmes styles que la FAQ de « Comment ça marche ».
const FaqLuxe = () => {
  const { t } = useTranslation('home');
  const groupes = t('faqPage.groups', { returnObjects: true });
  const liste = Array.isArray(groupes) ? groupes : [];

  return (
    <div className="how-it-works-page">
      <section className="how-hero">
        <div className="container-luxe">
          <span className="label-gold">{t('faqPage.eyebrow')}</span>
          <h1>{t('faqPage.title')}</h1>
          <p className="hero-description">{t('faqPage.intro')}</p>
        </div>
      </section>

      {liste.map((groupe, g) => (
        <section key={groupe.title} className="faq-section faq-page-group" aria-labelledby={`faq-groupe-${g}`}>
          <div className="container-luxe">
            <div className="section-header">
              <h2 id={`faq-groupe-${g}`}>{groupe.title}</h2>
            </div>
            <div className="faq-list">
              {(groupe.items || []).map((item) => (
                <details key={item.q} className="faq-item">
                  <summary className="faq-question">{item.q}</summary>
                  <p className="faq-answer">
                    {item.a}
                    {item.link && <> <Link to={item.link.to}>{item.link.label}</Link></>}
                  </p>
                </details>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* Contact : un formulaire plutot qu'une adresse e-mail (demande du fondateur, 2026-10-29). */}
      <section className="faq-section faq-page-group" id="contact" aria-labelledby="faq-contact">
        <div className="container-luxe">
          <div className="section-header">
            <h2 id="faq-contact">{t('faqPage.contact.title')}</h2>
            <p className="section-subtitle">{t('faqPage.contact.intro')}</p>
          </div>
          <ContactForm />
        </div>
      </section>

      <section className="how-cta">
        <div className="container-luxe">
          <h2>{t('howItWorks.cta.title')}</h2>
          <Link to="/create-book" className="btn btn-primary how-hero-cta">{t('howItWorks.cta.button')}</Link>
          <p className="cta-note">{t('howItWorks.cta.note')}</p>
        </div>
      </section>
    </div>
  );
};

export default FaqLuxe;
